let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("dBusn")).then(() => parcelRequire('9HUoo'));